import React from "react";
import styles from "./medicFooter.module.css";
import { Col, Row, Typography, Space } from "antd";
import { FaPhone, FaGlobe, FaQrcode } from "react-icons/fa";
import AppStoreImg from "../../../assets/images/appstore.png";
import PlayStoreImg from "../../../assets/images/playstore.png";
import QrAppImg from "../../../assets/images/qr-app.png";

const { Text, Link } = Typography;
const getDomainName = (url) => {
    const hostname = new URL(url).hostname;
    return hostname.replace(/^www\./, '');
}
export default function MedicFooter() {
  const hotline = process.env.REACT_APP_HOTLINE_PHONE || '0915131515';
  const websiteUrl = process.env.REACT_APP_WEBSITE_URL || 'https://medichospital.com';
  const appStoreUrl = process.env.REACT_APP_APPSTORE_URL || 'https://apps.apple.com/vn/app/my-medic/id6477986788';
  const playStoreUrl = process.env.REACT_APP_PLAYSTORE_URL || 'https://play.google.com/store/apps/details?id=com.ytemedic';
  const companyName = process.env.REACT_APP_COMPANY_NAME || 'HỆ THỐNG Y TẾ MEDIC';
  const copyrightYear = process.env.REACT_APP_COPYRIGHT_YEAR || '2024';

  // Format hotline with spaces
  const formattedHotline = hotline.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <Row gutter={[24, 24]} justify="space-between" align="middle">
          {/* Cột 1: Thông tin hệ thống và hotline */}
          <Col xs={24} md={12}>
            <div className={styles.infoSection}>
              <div className={styles.title}>
                {companyName}
              </div>
              <Space direction="vertical" size="small">
                <Text className={styles.descriptionText}>
                   {process.env.REACT_APP_SLOGAN}
                </Text>
                <div>
                  <Text className={styles.labelText}>
                    Hotline hỗ trợ 24/7:
                  </Text>
                  <a href={`tel:${hotline}`} className={styles.hotline}>
                    <FaPhone />
                    {formattedHotline}
                  </a>
                </div>
                <div>
                  <Link
                    href={websiteUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.link}
                  >
                    <FaGlobe />
                    {getDomainName(websiteUrl)}
                  </Link>
                </div>
              </Space>
            </div>
          </Col>

          {/* Cột 2: QR code + nút tải app */}
          <Col xs={24} md={12}>
            <div className={styles.appSection}>
              <div>
                <div className={styles.qrContainer}>
                  <img 
                    src={QrAppImg} 
                    width={80} 
                    height={80} 
                    alt="QR Code" 
                    className={styles.qrImage}
                  />
                </div>
                <Text className={styles.qrLabel}>
                  <FaQrcode />
                  Quét mã QR
                </Text>
              </div>
              
              <div style={{ flex: 1 }}>
                <div className={styles.title}>
                  {process.env.REACT_APP_APP_NAME}
                </div>
                <Text style={{ color: "var(--theme-sub-text-color)", fontSize: "12px", display: "block", marginBottom: 8 }}>
                  {process.env.REACT_APP_SLOGAN}
                </Text>
                <div className={styles.appButtons}>
                  <a
                    href={appStoreUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.appButton}
                  >
                    <img
                      src={AppStoreImg}
                      alt="Tải trên App Store"
                      height={36}
                      className={styles.appButtonImage}
                    />
                  </a>
                  <a
                    href={playStoreUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.appButton}
                  >
                    <img
                      src={PlayStoreImg}
                      alt="Tải trên Play Store"
                      height={36}
                      className={styles.appButtonImage}
                    />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        
        {/* Copyright section */}
        <div className={styles.copyright}>
          <Text>
            © {copyrightYear} {companyName}. All rights reserved.
          </Text>
        </div>
      </div>
    </footer>
  );
}
